<template>
    <div class="display-mode-value-wrapper">
        <input v-if="isSingleLineDisplayType" v-model="displayValue" type="text" class="static-edit-in-place-value" :class="{'ghost-text':ghostText}">
        <div v-if="isMultiLineDisplayType" class="input-area">
            <html-wrapper v-if="isHTML" :value="displayValue" mode="display" class="static-edit-in-place-value" ref="htmlEditor"></html-wrapper>
            <textarea v-else v-model="displayValue" class="static-edit-in-place-value" rows="5"></textarea>
        </div>
        <div class="cloud-tag" v-if="isPropertyValueArray">
            <div class="tag" :class="{'ghost-tag':ghostText}" v-for="value in displayValue" :key="value">{{value}}</div>
        </div>
    </div>
</template>

<script>
import HTMLWrapper from './html-wrapper.vue';
export default {
    name: 'display-mode',
    components: {
        'html-wrapper': HTMLWrapper
    },
    props: {
        type: String,
        displayValue: {
            type: [Array, String],
        },
        ghostText: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        isSingleLineDisplayType() {
            return (this.type === 'short-text' || this.type === 'number' || this.type === 'datetime' || this.type === 'date' || this.type === 'single-select');
        },
        isMultiLineDisplayType() {
            return (this.type === 'long-text' || this.type === 'markdown' || this.type === 'json' || this.type === 'html');
        },
        isHTML() {
            return this.type === 'html';
        },
        isPropertyValueArray() {
            return (Array.isArray(this.displayValue));
        }
    }
}
</script>
<style lang="scss">
.display-mode-value-wrapper {
    .note-resizebar,
    .note-statusbar,
    .note-toolbar-wrapper {
        display: none !important;
    }
    .note-editor.note-frame,
    .note-editable {
        border: none !important;
        background-color: transparent !important;
    }
    .note-editable {
        white-space: initial !important;
    }
}
</style>
